import { GlobalConfig } from 'galarm-config'

const FirebaseManager = (function () {
  let unsubs = {}

  const listenToConnectedAccountsForUser = function (key, userId, callback) {
    const connectedAccountsCollection =
      GlobalConfig.firebaseHelpers.collectionRef(
        `userInfos/${userId}/connectedAccounts`
      )
    const unsub = GlobalConfig.firebaseHelpers.onSnapshot(
      connectedAccountsCollection,
      snapshot => {
        callback(snapshot)
      }
    )

    // Add unsub to array with key in unsubs object
    if (unsubs[key]) {
      unsubs[key].push(unsub)
    } else {
      unsubs[key] = [unsub]
    }
  }

  const listenToIncidentAlarmsForUser = function (key, userId, callback) {
    // Get the last 50 incident alarms for the user
    const incidentAlarmsCollection = GlobalConfig.firebaseHelpers.collectionRef(
      `userInfos/${userId}/incidentAlarms`
    )
    const orderByConstraint = GlobalConfig.firebaseHelpers.orderBy(
      'date',
      'desc'
    )
    const limitConstraint = GlobalConfig.firebaseHelpers.limit(50)
    const queryRef = GlobalConfig.firebaseHelpers.createFirestoreQuery(
      incidentAlarmsCollection,
      orderByConstraint,
      limitConstraint
    )
    const unsub = GlobalConfig.firebaseHelpers.onSnapshot(
      queryRef,
      snapshot => {
        callback(snapshot)
      }
    )

    // Add unsub to array with key in unsubs object
    if (unsubs[key]) {
      unsubs[key].push(unsub)
    } else {
      unsubs[key] = [unsub]
    }
  }

  const listenToCalendarEventsForUser = function (key, userId, callback) {
    // Get calendar events for the user where isActive is true
    const calendarEventsCollection = GlobalConfig.firebaseHelpers.collectionRef(
      `userInfos/${userId}/calendarEvents`
    )
    const whereConstraint = GlobalConfig.firebaseHelpers.where(
      'isActive',
      '==',
      true
    )
    const queryRef = GlobalConfig.firebaseHelpers.createFirestoreQuery(
      calendarEventsCollection,
      whereConstraint
    )
    const unsub = GlobalConfig.firebaseHelpers.onSnapshot(
      queryRef,
      snapshot => {
        callback(snapshot)
      }
    )

    // Add unsub to array with key in unsubs object
    if (unsubs[key]) {
      unsubs[key].push(unsub)
    } else {
      unsubs[key] = [unsub]
    }
  }

  const unsubscribeAllListeners = function () {
    for (const key in unsubs) {
      if (unsubs[key]) {
        unsubs[key].forEach(unsub => {
          unsub()
        })
      }
    }
  }

  const unsubscribeListenersForKey = function (key) {
    if (unsubs[key]) {
      unsubs[key].forEach(unsub => {
        unsub()
      })
    }
  }

  return {
    listenToConnectedAccountsForUser,
    listenToCalendarEventsForUser,
    listenToIncidentAlarmsForUser,
    unsubscribeAllListeners,
    unsubscribeListenersForKey
  }
})()

export default FirebaseManager
